export default __webpack_public_path__ + "6a2c5a2.png";